import { Worksheet } from '../../../types/worksheet';
import WorksheetHistory from '../../worksheet/history/WorksheetHistory';
import PreviewSection from '../PreviewSection';

type HistoryPreviewProps = {
    worksheet: Worksheet;
};
function HistoryPreview({ worksheet }: HistoryPreviewProps): JSX.Element {
    return (
        <PreviewSection title="History" defaultCollapsed>
            <div className="mt-2 pl-4">
                <WorksheetHistory worksheet={worksheet} />
            </div>
        </PreviewSection>
    );
}

export default HistoryPreview;
